import { render, staticRenderFns } from "./organization_setting.vue?vue&type=template&id=06107d6e&"
import script from "./organization_setting.vue?vue&type=script&lang=js&"
export * from "./organization_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports